import { Injectable } from '@angular/core';

import { BehaviorSubject, combineLatest } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';

import { CmsCollectionEnum } from '@lib-shared/cms/models/cms-collection.enum';

import { CmsStoreService } from '@lib-shared/cms/services/cms-store.service';

import { injectAuthFeature } from '@mymill/core/auth';

@Injectable({
  providedIn: 'root',
})
export class LayoutCoreSplashscreenService {
  // init observables
  isAnimationActive$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isAnimationCompleted$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isActive$ = this.isAnimationCompleted$.pipe(
    map((isCompleted) => !isCompleted),
  );

  private readonly authFeature = injectAuthFeature();

  // init animationTriggers
  animationTriggers = this.authFeature.isReady$.pipe(
    //filter((isReady) => isReady),
    switchMap(() => this.authFeature.isLoggedIn$),
    switchMap((isLoggedIn) => {
      const loaders = [
        this.cmsStoreService.getCollectionIsLoaded(CmsCollectionEnum.I18n),
        this.cmsStoreService.getCollectionIsLoaded(
          CmsCollectionEnum.Configuration,
        ),
      ];

      if (isLoggedIn) {
        loaders.push(
          this.cmsStoreService.getCollectionIsLoaded(CmsCollectionEnum.Amenity),
        );
      }

      return combineLatest(loaders);
    }),
    map((loaders) => loaders.every((loader) => loader)),
  );

  /**
   * constructor
   *
   */
  constructor(
    //private authStoreService: AuthStoreService,
    private cmsStoreService: CmsStoreService,
  ) {}

  /**
   * init
   *
   */
  init(): void {
    this.animationTriggers
      .pipe(
        filter((trigger) => trigger),
        take(1),
        tap(() => {
          this.runAnimation();
        }),
      )
      .subscribe();
  }

  /**
   * runAnimation
   *
   */
  private runAnimation(): void {
    this.isAnimationActive$.next(true);
  }
}
